export function getUsersWhoPresenceOnItem({ presenceData, currentUserId, itemUuid }) {
  return Object.keys(presenceData).reduce(
    (accum, userId) =>
      presenceData[userId].workspace_item_uuid === itemUuid && Number(userId) !== currentUserId
        ? [...accum, { userId: Number(userId), active: presenceData[userId].active }]
        : accum,
    []
  );
}
